import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import EnvelopDetail from '../../components/envelop/EnvelopDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { editEnvelop, getEnvelop } from '../../redux/envelop/envelop_actions';

class EnvelopEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.envelopDetail = undefined;
  }

  onSaveHandler() {
    const editedEnvelop = this.envelopDetail.getWrappedInstance().getWrappedInstance().getEnvelopData();
    this.props.editEnvelop({ ...editedEnvelop, id: this.props.envelop.id });
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.envelop !== nextProps.envelop) && nextProps.show) {
      this.props.getEnvelop(nextProps.envelop.id, nextProps.envelop.type);
    }
  }

  render() {
    const { isEditing, errorMessage, editEnvelop, getEnvelop, envelopDetail, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit envelop')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EnvelopDetail
            isShowWWR={true}
            envelop={envelopDetail}
            building={building}
            ref={ref => (this.envelopDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="envelop-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.envelop.errorMessage,
  isEditing: state.envelop.isEditing,
  envelopDetail: props.envelop && state.envelop.objects[props.envelop.id],
});

const mapDispatchToProps = (dispatch, props) => ({
  editEnvelop: env =>
    defaultRejectHandler(
      dispatch(
        editEnvelop(env.id, env.name, env.zone_id, env.azimuth_angle, env.inclination, env.description, props.envelop.type)),
    ),
  getEnvelop: (id, type) => defaultRejectHandler(dispatch(getEnvelop(id, type))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnvelopEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/envelop/EnvelopEditModal.js